import styled from 'styled-components';
import { LinkPartial } from '../../partials/link';
import { TypographyStyles, colours, media, spacing } from '../../stylings';

export const StyledDesktopCard = styled.article<{ $extendWidth: boolean }>`
  display: none;
  @media ${media.greaterThan('lg')} {
    display: initial;
    gap: ${spacing.XS};
    max-width: ${({ $extendWidth }) => ($extendWidth ? '255px' : '190px')};
  }
`;

export const StyledMobileCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXXXS};
  max-width: 262px;
  width: 100%;
  @media ${media.greaterThan('lg')} {
    display: none;
  }
`;

export const CardWrapper = styled.figure`
  gap: ${spacing.XXXS};
  margin: 0;
  span {
    @media ${media.greaterThan('lg')} {
      gap: ${spacing.XXS};
      outline: 1.13px solid ${colours.LIGHTER_GREY};
    }
  }
`;

export const Title = styled.span`
  ${TypographyStyles.Label.Large.Medium}
  display: block;
  font-size: 16px;
  margin: 0 0 ${spacing.XXXS} 0;
  text-align: left;
  white-space: normal;
  width: 280px;
  @media ${media.greaterThan('lg')} {
    border-radius: 0;
    font-size: 14px;
    margin: 0 0 ${spacing.XXXXS} 0;
    min-height: 22px;
    text-align: left;
    width: inherit;
  }
`;

export const Link = styled.div`
  font-size: 14px;
  a {
    color: inherit;
    display: flex;
    font-weight: 300;
    text-decoration: none;
  }
`;

export const TexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXXXS};
  justify-content: center;
  margin: 0;
`;

export const StyledCTA = styled.span`
  ${TypographyStyles.CallToAction.Tiny.SemiBold}
  font-size: 14px;
  text-align: left;
  text-decoration-line: underline;
  text-transform: capitalize;
  white-space: normal;
  @media ${media.greaterThan('lg')} {
    font-size: 12px;
  }
`;

export const StyledLinkPartial = styled(LinkPartial)`
  display: flex;
  flex-direction: column;
  justify-content: left;
  margin: 0px;
  padding: 0px;
`;
